
import { AbstractTracker } from './AbstractTracker';

/**
 * The process tracker is an event-driven wrapper around tracking the progress of an Ally Process. When
 * created, the tracker will begin tracking progress immediately, emitting a `progress` event on each
 * polling interval. If it fails, an 'error' event is emitted. On success, a 'finished' event is emitted.
 *
 * @param  {String}     processId   The id of the process to track
 * @param  {Number}     interval    How long to wait between polling intervals
 */
export function ProcessTracker(processId, interval) {
    this.processId = processId;
    this.interval = interval || 1000;

    // Begin tracking immediately
    this._poll();
}

ProcessTracker.prototype = Object.create(AbstractTracker.prototype);
ProcessTracker.prototype.constructor = ProcessTracker;
ProcessTracker.prototype.url = function() {
    return `/api/v1/processes/${ this.processId}`;
};
